import styled from 'styled-components';

const SurfaceHeader = styled.div`
    margin: ${props => props.theme.spacing(-2, -2, 2, -2)};
    padding: ${props => props.theme.spacing(0, 2)};
    display: flex;
    align-items: center;
    min-height:48px;
    border-bottom: 1px solid ${props => props.theme.palette.ui.border};
    gap: ${props => props.theme.spacing(1)};

    > :first-child {
        flex: 1 0 auto;
    }
`;

export default SurfaceHeader;
export { SurfaceHeader };